import React from 'react';
import { Button, Input, InputNumber, Modal, Popconfirm } from 'antd';
import {ArrowRightOutlined, DeleteOutlined, ExclamationCircleOutlined, PlusOutlined} from '@ant-design/icons';
import moment from 'moment';
import { useMutation } from '@apollo/client';
import { UPDATE_CLIENT } from '../../../graphql/client';
import { UPDATE_PARENT } from '../../../graphql/parent';
import _ from 'lodash';

export default function ClientIndicator({client, type, indicator, onUpdate }) {

    const [value, setValue] = React.useState(null);

    const [updateMutation, { loading }] = useMutation(type === 'child' ? UPDATE_CLIENT : UPDATE_PARENT);

    const onSubmit = async () => {

        const results = _.map(indicator.result, item => ({id: item.id}));
        results.push({
            date: moment().format('YYYY-MM-DD'),
            value: value,
        })
        const indicators = _.map(client?.attributes?.indicator, (item) => {
            if (item.id === indicator.id) {
                return {
                    id: item.id,
                    result: results,
                };
            } else {
                return { id: item.id };
            }
        });
        await updateMutation({
            variables: {
                id: client.id,
                data: {
                    indicator: indicators,
                }
            },
            onCompleted: () => {
                setValue(null)
                onUpdate();
            }
        })

    };

    const onDelete = async () => {
        const indicators = _.map(client?.attributes?.indicator, item => ({id: item.id}));
        const filtred = indicators.filter(item => item.id !== indicator.id);

        await updateMutation({
            variables: {
                id: client.id,
                data: {
                    indicator: filtred,
                }
            },
            onCompleted: () => {
                onUpdate();
            }
        })
    }

    let results = null;

    const lastThreeResults = indicator?.result?.slice(-3);

    results = _.map(lastThreeResults, item => (
        <div key={'result' + item.id} className={'crm-indicator-results-col'}>
            <div className={'caption'}>{moment(item.date).format('DD.MM.YYYY')}</div>
            <Input size={'large'} value={item.value} disabled />
        </div>
    ))

    return (
        <div className="crm-indicator">
            <div className={'crm-indicator-title'}>
                <span>{indicator.name}</span>
                <span className={'bold'}>
                    {indicator.startValue} <ArrowRightOutlined /> {indicator.goal}
                    <Popconfirm
                        title="Удалить цель"
                        description="Вы уверены что хотите удалить цель?"
                        onConfirm={onDelete}
                        okText="Да"
                        cancelText="Нет"
                    >
                        <Button type={'link'} icon={<DeleteOutlined />}/>
                    </Popconfirm>
                </span>
            </div>
            <div className={'crm-indicator-result'}>

                {results}

                <div className={'crm-indicator-results-col'}>
                    <div className={'caption'}>Сегодня</div>
                    <InputNumber value={value} size="large" onChange={(value) => setValue(+value)} />
                </div>

                <div className={'crm-indicator-results-col'}>
                    <div className={'caption'}>&nbsp;</div>
                    <Button loading={loading} size={'large'} icon={<PlusOutlined />} onClick={onSubmit} />
                </div>
            </div>
        </div>
    );
}